import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BUSINESS_SERVICE_CONTRACT',
    icon: 'menu-document',
    label: '服务合同管理',
    children: [
      {
        code: 'BUSINESS_SERVICE_CONTRACT_INTERMEDIARY',
        icon: 'menu-document',
        label: '居间合同',
        path: '/business-service-contract/intermediary',
      },
      {
        code: 'BUSINESS_SERVICE_CONTRACT_GUARANTEE',
        icon: 'menu-company-guarantee',
        label: '担保合同',
        path: '/business-service-contract/guarantee',
      },
      {
        code: 'BUSINESS_SERVICE_CONTRACT_WAREHOUSE_COOPERATION',
        icon: 'menu-company-warehouse',
        label: '仓储合作协议',
        path: '/business-service-contract/warehouse-cooperation',
      },
      {
        code: 'BUSINESS_SERVICE_CONTRACT_LOGISTICS_FRAMEWORK',
        icon: 'menu-logistics',
        label: '物流框架协议',
        path: '/business-service-contract/logistics-framework',
      },
      {
        code: 'BUSINESS_SERVICE_CONTRACT_CUSTOMS_AGENCY',
        icon: 'menu-company-customs',
        label: '代理报关协议',
        path: '/business-service-contract/customs-agency',
      },
      {
        code: 'BUSINESS_SERVICE_CONTRACT_OTHER',
        icon: 'menu-docx-templates',
        label: '其他服务协议',
        path: '/business-service-contract/other',
      },
    ],
  },
] satisfies Menu[];
